import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import moment from 'moment';
import Bundle from "../models/Bundle";
import AutoFill from "../models/AutoFill";

const initialState = {
    isFetching: false,
    isFetchingBundle: false,
    isFetchingCampaign: false,
    isFetchingAutoFill: false,
    isFetched: false,
    isFetchingDownload: false,
    isFetchingCheckCode: false,
    isFetchingHistory: false,
    promotions: [],
    bundles: [],
    campaigns: [],
    autoFills: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    autoFillPage: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
    },
    resultCheckCode: null,
    histories: {
        list: [],
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
    },
    errors: null,
    // bundle
    isFetchingBundleList: false,
    isFetchingUpsert: false,
    bundleLst: [],
    bundle: new Bundle(),
    bundleDetail: new Bundle(),
    autoFillDetail: new AutoFill(),
    isFetchingParseExcel: false,
    promotionCodesDetail: {},
    isFetchingDataStatusGroup: false,
    dataStatusGroup: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        // List Promotions
        case Types.PROMOTION_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.PROMOTION_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                promotions: action.promotions.result,
                pageSize: action.promotions.pageSize,
                pageIndex: action.promotions.pageIndex,
                totalCount: action.promotions.totalCount,
                totalPage: Math.ceil(parseInt(action.promotions.totalCount) / parseInt(action.promotions.pageSize)),
                ...action.params,
            };
        case Types.PROMOTION_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, promotions: [] };

        // Deactive Code
        case Types.PROMOTION_CHANGE_STATUS_CODE_ACTION:
            return { ...state, isFetching: true };
        case Types.PROMOTION_CHANGE_STATUS_CODE_SUCCESS:
            return { ...state, isFetching: false }
        case Types.PROMOTION_CHANGE_STATUS_CODE_FAIL:
            return { ...state, isFetching: false };

        // Get Campaigns
        case Types.PROMOTION_CAMPAIGN_LIST_FILTER_ACTION:
        case Types.PROMOTION_CAMPAIGN_LIST_ACTION:
            return { ...state, isFetchingCampaign: true };
        case Types.PROMOTION_CAMPAIGN_LIST_FILTER_SUCCESS: 
        case Types.PROMOTION_CAMPAIGN_LIST_SUCCESS:
            return {
                ...state,
                isFetchingCampaign: false,
                campaigns: action.campaigns,
            };
        case Types.PROMOTION_CAMPAIGN_LIST_FILTER_FAIL:
        case Types.PROMOTION_CAMPAIGN_LIST_FAIL:
            return { ...state, isFetchingCampaign: false, campaigns: [] };

        // Get Bundles
        case Types.BUNDLE_LIST_ACTION:
            return { ...state, isFetchingCampaign: true };
        case Types.BUNDLE_LIST_SUCCESS:
            return {
                ...state,
                isFetchingCampaign: false,
                bundles: action.bundles,
            };
        case Types.BUNDLE_LIST_FAIL:
            return { ...state, isFetchingCampaign: false, bundles: [] };

        // Get Bundle detail
        case Types.BUNDLES_DETAIL_ACTION:
            return { ...state, isFetchingCampaign: true };
        case Types.BUNDLES_DETAIL_SUCCESS:
            return {
                ...state,
                isFetchingCampaign: false,
                bundleDetail: action.bundle,
            };
        case Types.BUNDLES_DETAIL_FAIL:
            return { ...state, isFetchingCampaign: false };
        //Get autoFills
        case Types.AUTOFILL_LIST_ACTION:
            return { ...state, isFetchingAutoFill: true };
        case Types.AUTOFILL_LIST_SUCCESS:
            return {
                ...state,
                isFetchingAutoFill: false,
                autoFillPage: {
                    pageSize: action.autoFill.pageSize,
                    pageIndex: action.autoFill.pageIndex,
                    totalCount: action.autoFill.totalCount,
                    totalPage: Math.ceil(parseInt(action.autoFill.totalCount) / parseInt(action.autoFill.pageSize)),
                },
                autoFills: action.autoFill.result,
            };
        case Types.AUTOFILL_LIST_FAIL:
            return { ...state, isFetchingAutoFill: false, autoFills: [] };
        //create autoFill
        case Types.AUTOFILL_CREATE_ACTION:
            return { ...state, isFetchingUpsert: true };
        case Types.AUTOFILL_CREATE_SUCCESS:
            return { ...state, isFetchingUpsert: false };
        case Types.AUTOFILL_CREATE_FAIL:
            return { ...state, isFetchingUpsert: false };
        //get detail autoFill
        case Types.AUTOFILL_DETAIL_ACTION:
            return { ...state, isFetchingAutoFill: true, autoFillDetail: initialState.autoFillDetail, isFetched: false };
        case Types.AUTOFILL_DETAIL_SUCCESS:
            return {
                ...state,
                isFetchingAutoFill: false,
                isFetched: true,
                autoFillDetail: action.autoFill
            };

        // Export file 
        case Types.PROMOTION_EXPORT_FILE_ACTION:
            return { ...state, isFetchingDownload: true }
        case Types.PROMOTION_EXPORT_FILE_FAIL:
            return { ...state, isFetchingDownload: false }
        case Types.PROMOTION_EXPORT_FILE_SUCCESS:
            return { ...state, isFetchingDownload: false }
        // Check Promotion
        case Types.CHECK_PROMOTION_ACTION:
            return { ...state, isFetchingCheckCode: true, resultCheckCode: null }
        case Types.CHECK_PROMOTION_SUCCESS:
            return { ...state, isFetchingCheckCode: false, resultCheckCode: action.result }
        case Types.CHECK_PROMOTION_FAIL:
            return { ...state, isFetchingCheckCode: false, errors: action.errors }
        case Types.CHECK_PROMOTION_RESET:
            return { ...state, isFetchingCheckCode: false, resultCheckCode: null }

        // Get Histories Code
        case Types.PROMOTION_GET_HISTORY_CODE_ACTION:
            return {
                ...state,
                isFetchingHistory: true
            };
        case Types.PROMOTION_GET_HISTORY_CODE_SUCCESS:
            return {
                ...state,
                isFetchingHistory: false,
                histories: {
                    list: action.histories.data.result,
                    pageSize: action.histories.data.pageSize,
                    pageIndex: action.histories.data.pageIndex,
                    totalCount: action.histories.data.totalCount,
                    totalPage: Math.ceil(parseInt(action.histories.data.totalCount) / parseInt(action.histories.data.pageSize)),
                }
            };
        case Types.PROMOTION_GET_HISTORY_CODE_FAIL:
            return { ...state, isFetchingHistory: false, histories: { ...state.histories, list: [] } };
        case Types.PROMOTION_GET_HISTORY_CODE_RESET:
            return {
                ...state,
                histories: initialState.histories
            }
        // bundle
        case Types.BUNDLES_LIST_ACTION:
            return { ...state, isFetchingBundleList: true };
        case Types.BUNDLES_LIST_SUCCESS:
            return {
                ...state,
                isFetchingBundleList: false,
                bundleLst: action.bundles.result,
                pageSize: action.bundles.pageSize,
                pageIndex: action.bundles.pageIndex,
                totalCount: action.bundles.totalCount,
                totalPage: Math.ceil(parseInt(action.bundles.totalCount) / parseInt(action.bundles.pageSize)),
                ...action.params,
            };
        case Types.BUNDLES_LIST_FAIL:
            return { ...state, isFetchingBundleList: false, bundleLst: [] };
        case Types.BUNDLES_CREATE_ACTION:
            return { ...state, isFetchingUpsert: true };
        case Types.BUNDLES_CREATE_SUCCESS:
            return { ...state, isFetchingUpsert: false };
        case Types.BUNDLES_CREATE_FAIL:
            return { ...state, isFetchingUpsert: false };
        case Types.BUNDLES_DEACTIVATED_CODE_ACTION:
            return { ...state, isFetchingBundleList: true };
        //    Parse excel promotion codes
        case Types.BUNDLES_PARSE_EXCEL_ACTION:
            return { ...state, isFetchingParseExcel: true, promotionCodesDetail: {}, };
        case Types.BUNDLES_PARSE_EXCEL_SUCCESS:
            const data = action?.file?.data;
            return {
                ...state,
                isFetchingParseExcel: false,
                promotionCodesDetail: {
                    data: data?.data,
                    errors: data?.dataErrors,
                    validationError: data?.validationError,
                },
            };
        case Types.BUNDLES_PARSE_EXCEL_FAIL:
            return { ...state, isFetchingParseExcel: false, promotionCodesDetail: {}, };
        case Types.BUNDLES_PARSE_EXCEL_CLEAR_ERROR:
            return { ...state, isFetchingParseExcel: false, promotionCodesDetail: {}, };
        case Types.PROMOTION_BULK_UPDATE_STATUS_ACTION:
            return { ...state, isFetching: true }
        case Types.PROMOTION_BULK_UPDATE_STATUS_FAIL:
            return { ...state, isFetching: false }
        // Parse promotion status group
        case Types.IMPORT_FILE_ACTION:
            return { ...state, isFetchingDataStatusGroup: true, dataStatusGroup: null, };
        case Types.IMPORT_FILE_SUCCESS:
            const dataFile = action?.file;
            return {
                ...state,
                isFetchingDataStatusGroup: false,
                dataStatusGroup: {
                    data: dataFile?.data,
                    invalidCodes: dataFile?.invalidCodes,
                    errors: dataFile?.errors,
                    isSuccess: dataFile?.isSuccess,
                },
            };
        case Types.IMPORT_FILE_FAIL:
        case Types.CLEAR_STATUS_GROUP:
            return { ...state, isFetchingDataStatusGroup: false, dataStatusGroup: null, };
        default:
            return state;
    }
}
